import { render, staticRenderFns } from "./zmdet_i.vue?vue&type=template&id=37770937&scoped=true&"
import script from "./zmdet_i.vue?vue&type=script&lang=js&"
export * from "./zmdet_i.vue?vue&type=script&lang=js&"
import style0 from "./zmdet_i.vue?vue&type=style&index=0&id=37770937&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37770937",
  null
  
)

export default component.exports